export enum OfferStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum ToastType {
  SUCCESS = 'success',
  ERROR = 'error',
}
